import * as React from 'react';
import { IMVKSectionInfo } from '../../types/newbuilding/mvk';
import { Spinner } from '../Spinner';
import { Label } from './internal/Label/Label';
import { OffersCount } from './internal/OffersCount/OffersCount';
import { Title } from './internal/Title/Title';
import * as styles from './styles.css';

interface IMVKPreloaderProps {
  name: string;
  mvkData: IMVKSectionInfo[];
  link: string;
}

export function MVKPreloader(props: IMVKPreloaderProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['loader']}>
        <Spinner fillColor={'#737A8E'} />
      </div>
      <div className={styles['information']}>
        <h4 className={styles['title']}>Корпуса в {props.name}</h4>
        <ul className={styles['houses']}>
          {props.mvkData.map(item => (
            <li key={`${item.houseTitle}${item.sectionTitle}`} className={styles['house']}>
              <div className={styles['header']}>
                <Title houseTitle={item.houseTitle} sectionTitle={item.sectionTitle} />
                <div className={styles['label']}>
                  <Label completionStatus={item.completionStatus} />
                </div>
              </div>
              <span className={styles['info']}>
                <OffersCount offersCount={item.offersCount} />
              </span>
              <ul className={styles['house_info_list']}>
                {item.rooms.map(room => (
                  <li
                    key={`${item.houseTitle}${item.sectionTitle}${room.squareInfo}`}
                    className={styles['house_info_list_item']}
                  >
                    <span>{room.squareInfo}</span> <span>{room.priceFrom}</span>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <div className={styles['nearby']}>
          <a className={styles['link']} href={props.link}>
            Предложения рядом
          </a>
        </div>
      </div>
    </div>
  );
}

MVKPreloader.displayName = 'MVKPreloader';
